import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/auth/AuthContext";

export const ProtectedRoute = ({ children, requireProfile = true, requireAdmin = false }) => {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return <div className="journey-loading" data-testid="auth-loading-state" />;
  }
  if (!user) {
    const returnTo = `${location.pathname}${location.search}`;
    return <Navigate to={`/signin?returnTo=${encodeURIComponent(returnTo)}`} replace />;
  }
  if (requireProfile && !user.profile_completed) {
    const returnTo = `${location.pathname}${location.search}`;
    return <Navigate to={`/profile?returnTo=${encodeURIComponent(returnTo)}`} replace />;
  }
  if (requireAdmin && !user.is_admin) {
    return <Navigate to="/account" replace />;
  }
  return children;
};